<template>
    <initials :fullName="data.name" :color="color"></initials>
</template>

<script>
    import Initials from '../../Common/Initials'
    export default {
        name: 'ReportSpecialist',
        components: {
            Initials
        },
        props: {
            data: Object
        },
        computed: {
            color() {
                return this.data.signed ? '#37E074' : null
            }
        }
    }
</script>

<style scoped>

</style>